import React from 'react'
import { useSupportButtonLogic } from './SupportButton.logic'
import SupportButtonView from './SupportButton.view'

function SupportButton() {
  const logicResults = useSupportButtonLogic()
  return <SupportButtonView {...logicResults} />
}

export default SupportButton
